import { useThemeObserver } from '@atlaskit/tokens/use-theme-observer';

import type { AgentPresenceColorMode } from './presenceIconChrome.ts';

export const useAgentAvatarColorMode = (): AgentPresenceColorMode => {
	const { colorMode } = useThemeObserver();
	return colorMode === 'dark' ? 'dark' : 'light';
};
